import React, { useState, useEffect } from 'react';
import { Text, Input, Button } from "@geist-ui/core";
import { Settings, Save, X } from "@geist-ui/icons"; // Add X import
import './SettingsWindow.css';

const SettingsWindow = ({ position, onDragEnd, onSettingsSave, onClose }) => { // Add onClose prop
  const [isDragging, setIsDragging] = useState(false);
  const [dragPos, setDragPos] = useState(position);
  const [playerName, setPlayerName] = useState('');
  const [playerImage, setPlayerImage] = useState(null);

  // Load saved settings on mount
  useEffect(() => {
    const savedName = localStorage.getItem('playerName');
    const savedImage = localStorage.getItem('playerImage');
    if (savedName) setPlayerName(savedName);
    if (savedImage) setPlayerImage(savedImage);
  }, []);

  // Dragging handlers
  const handleMouseDown = (e) => {
    if (e.target.classList.contains('settings-window-header')) {
      setIsDragging(true);
    }
  };

  const handleMouseMove = (e) => {
    if (isDragging) {
      setDragPos(prevPos => ({
        x: prevPos.x + e.movementX,
        y: prevPos.y + e.movementY
      }));
    }
  };

  const handleMouseUp = () => {
    if (isDragging) {
      setIsDragging(false);
      onDragEnd(dragPos);
    }
  };

  const handleNameChange = (e) => {
    const newName = e.target.value;
    setPlayerName(newName);
    localStorage.setItem('playerName', newName);
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const imageData = event.target.result;
        setPlayerImage(imageData);
        localStorage.setItem('playerImage', imageData);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSave = () => {
    // Save name
    localStorage.setItem('playerName', playerName);
    
    // Save image if one exists
    if (playerImage) {
      localStorage.setItem('playerImage', playerImage);
    }

    // Notify parent component that settings were saved
    onSettingsSave();
  };

  return (
    <div 
      className="settings-window"
      style={{ 
        transform: `translate(${dragPos.x}px, ${dragPos.y}px)`,
        cursor: isDragging ? 'grabbing' : 'auto'
      }}
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseUp}
    >
      <div className="settings-window-header">
        <Settings size={20} />
        <Text small>Settings</Text>
        <button className="close-button" onClick={onClose}> {/* Add onClick handler */}
          <X size={20} />
        </button>
      </div>
      <div className="settings-window-content">
        {/* Show preview at the top if image exists */}
        {playerImage && (
          <div className="settings-section">
            <Text small>Current Player Token</Text>
            <div className="image-preview" style={{ display: 'flex', justifyContent: 'flex-start' }}>
              <div>
                <img 
                  src={playerImage} 
                  alt="Player Token"
                  style={{ 
                    width: '50px', 
                    height: '50px', 
                    borderRadius: '25px',
                    marginLeft: '0'  // Add this to ensure left alignment
                  }}
                />
              </div>
            </div>
          </div>
        )}

        <div className="settings-section">
          <Text small>Player Name</Text>
          <Input 
            value={playerName}
            onChange={handleNameChange}
            width="100%"
            placeholder="Enter your name"
          />
        </div>
        
        <div className="settings-section">
          <Text small>Player Token Upload</Text>
          <input
            type="file"
            accept="image/*"
            onChange={handleImageUpload}
            className="image-upload"
          />
        </div>

        <div className="settings-section">
          <Button 
            icon={<Save />} 
            onClick={handleSave}
            width="100%"
            className="theme-button theme-button--w100"
          >
            Save Settings
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SettingsWindow;